import { LitElement, html, css, styleMap, utils } from '@hh/global.js'
class HHStickyHeader extends LitElement {
  static properties = {
    closeWhenHidden: {
      type: String,
      attribute: 'close-when-hidden',
    },
    _state: {
      type: Number,
      state: true,
    },
    _height: {
      type: Number,
      state: true,
    },
    enableTransparent: {
      type: Boolean,
      attribute: 'enable-transparent',
    },
    transparent: {
      type: Boolean,
      reflect: true,
    }
  }

  constructor() {
    super()

    this.headerBounds = {}
    this.currentScrollTop = 0
    this.closeWhenHidden = 'hh-details-modal'

    this._state = -1
  }

  connectedCallback() {
    super.connectedCallback()
    document.body.classList.add('is-header-sticky')
    this.onScrollHandler = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScrollHandler)
    window.addEventListener('resize', this.setSpacerHeight)

    setTimeout(() => {
      this.setSpacerHeight()
    });

    this.createObserver()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('scroll', this.onScrollHandler)
    window.removeEventListener('resize', this.setSpacerHeight)
  }

  setSpacerHeight() {
    const { height: _heightAnnouncementbar } = document
      .querySelector('.js-announcement-bar')
      .getBoundingClientRect()

    const { height: _heightHeader } = document
      .querySelector('.js-header')
      .getBoundingClientRect()

    this._initialHeight = _heightAnnouncementbar + _heightHeader
    this._height = this.enableTransparent ? 0 : this._initialHeight
    this._state = 0
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect
      observer.disconnect()
    })

    observer.observe(this)
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.hide.bind(this))
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.reveal.bind(this))
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this))
    }

    if (this.enableTransparent) {
      this.toggleTransparent()
    }

    this.currentScrollTop = scrollTop
  }

  onMouseEnter() {
    if (!this.enableTransparent) return

    this.transparent = false
  }

  onMouseLeave() {
    if (!this.enableTransparent) return
    this.toggleTransparent()
  }

  async toggleTransparent() {
    await this.updateComplete

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    this.transparent = scrollTop <= this._initialHeight
  }

  hide() {
    if (this._state === 1) {
      return
    }
    this._state = 1

    utils.all(this.closeWhenHidden, this.header).map((element) => {
      element.setAttribute('open', false)
    })
  }

  reveal() {
    if (this._state === 2) {
      return
    }
    this._state = 2
  }

  reset() {
    if (this._state === 0) {
      return
    }
    this._state = 0
  }

  render() {
    return html`<div
        class="container"
        style="${styleMap({
          position: this._state === -1 ? 'relative' : 'fixed',
          transform: this._state === 1 ? `translateY(-100%)` : 'translateY(0)',
        })}"
        @mouseenter=${this.onMouseEnter}
        @mouseleave=${this.onMouseLeave}
      >
        <slot></slot>
      </div>
      <div
        class="spacer"
        style="${styleMap({
          height: `${this._height}px`,
        })}"
      ></div>`
  }

  static styles = css`
    .container {
      left: 0;
      width: 100%;
      z-index: var(--hh-z-index, 100);
      transform: translateY(0);
      transition: transform var(--hh-duration-long, 500ms);
      background-color: var(--hh-background, transparent);
    }

    .spacer {
      position: relative;
    }
  `
}

customElements.define('hh-sticky-header', HHStickyHeader)
